export enum SystemPageKey {
  StartPage = 'StartPage',
  NotFound = 'NotFound',
  PDP = 'MachineDetails',
  SearchResults = 'SearchResults',
  CompareMachines = 'CompareMachines',
  InternalServerError = 'InternalServerError',
}
